
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agenda-online-para-barbearia",
      function () {
        return require("private-next-pages/agenda-online-para-barbearia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agenda-online-para-barbearia"])
      });
    }
  